import axios from "axios";

axios.interceptors.request.use(
  (config) => {
    //config.baseURL = "http://localhost:5000/api/";
    config.baseURL = "https://marianopuglisi.com/be/api/";
    //config.baseURL = "/be/api/";
    //config.baseURL =
    //  "http://cursosonline.cuarentacero.com/cuarentacero_api/api/";
    //config.headers = { Origin: "*" };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(null, (error) => {
  /*
  const errores =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!errores) {
    console.log("Log de error: " + error);
    toast.error(config.mensajes.errorGenerico);
  }
  */

  //No autorizado, el token expiró
  if (error.response.status) {
    if (error.response.status === 401 || error.response.status === 403) {
      localStorage.clear();
      alert("La sesión finalizó o no ha iniciado sesión.");
    }
  }

  return Promise.reject(error);
});

/*
export default axios.create({
  baseURL: "http://localhost:5000/api/",
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
});
*/

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
